import { useQuery } from '@tanstack/react-query';
import { regionsApi } from '../api/regions.api';
import type { RegionDetail } from '../types/regions.types';
import { regionKeys } from './queryKeys';

export const useRegion = (id: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: regionKeys.detail(id!),
    queryFn: () => regionsApi.getRegionById(id!),
    enabled: !!id,
  });

  return {
    region: data?.data as RegionDetail | undefined,
    isLoading,
  };
};
